import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetProps} from '../../hooks/widget-props'
import {classes} from './empty-state.st.css'

export const EmptyState = () => {
  const {t} = useWidgetProps()
  const {isMobile} = useEnvironment()

  return (
    <div data-hook={DH.NO_SCHEDULE_EMPTY_STATE} className={classNames(classes.root, {[classes.mobile]: isMobile})}>
      {t('scheduleEmptyStateText')}
    </div>
  )
}
